<template>
    <div>
        <span :class="{'visible': showBottom, 'drop-shadow' : true, 'bottom' : true}"></span>
        <span :class="{'visible': showTop, 'drop-shadow' : true, 'top' : true}"></span>
    </div>
</template>

<script>
    export default {
        name: "DropShadow",

        data: function() {
            return {
                showBottom: false,
                showTop: false
            }
        },

        methods: {
            handleScroll () {
                if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
                    this.showBottom = false;
                }
                else {
                    this.showBottom = true;
                }

                this.showTop = !(window.pageYOffset <= 2);
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleScroll);
        },
        mounted () {
            this.handleScroll();
        }
    }
</script>

<style scoped lang="scss">
    .drop-shadow {
        position: fixed;

        left: 50%;
        transform: translateX(-50%);
        width: calc(100% + 20px);

        height: 20px;

        pointer-events: none;

        transition: opacity .3s;
        opacity: 0;

        &.visible {
            opacity: 1;
        }

        &.bottom {
            bottom: -25px;
            box-shadow: 0px -7px 20px 0px rgba(55, 55, 55, 0.61);
        }

        &.top {
            top: -25px;
            box-shadow: 0px 7px 20px 0px rgba(55, 55, 55, 0.61);
        }
    }
</style>